import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Button, Icon, Loader, Modal } from "semantic-ui-react";

import { XENTRY_ROW_TYPE, buildXentryRows } from "modules/AppointmentDetails/components/CarDetails/components/XentryStatus/components/XentryStatusModal/utils";
import "modules/AppointmentDetails/components/CarDetails/components/XentryStatus/components/XentryStatusModal/XentryStatusModal.scss";

import type { XentryJob } from "modules/AppointmentDetails/components/CarDetails/components/XentryStatus/queryKeys";

type XentryStatusModalProps = {
  isOpen: boolean;
  loading: boolean;
  data?: XentryJob;
  onRefresh: () => void;
  onClose: () => void;
};

export const XentryStatusModal = ({ data, isOpen, loading, onRefresh, onClose }: XentryStatusModalProps) => {
  const { t } = useTranslation();

  const rows = useMemo(() => (data ? buildXentryRows(data) : []), [data]);

  return (
    <Modal size="small" open={isOpen} className="XentryStatusModal" dimmer="blurring" closeOnDimmerClick={false} onClose={onClose}>
      <Modal.Header className="XentryStatusModalHeading">
        <div>Xentry {t("v8_status", "Status")}</div>
        <div className="controls">
          <div className="icon-container">
            <Icon className="rotate" onClick={onRefresh} disabled={loading} color="green" />
          </div>
          <Button className="modal-close-btn" basic onClick={onClose}>
            <Icon className="xmark" />
          </Button>
        </div>
      </Modal.Header>

      <Modal.Content className={`XentryStatusModalContent ${!rows.length ? "NoData" : ""}`}>
        {loading && <Loader active size="small" className="Loader" />}
        {!loading && !rows.length && <p>{t("v8_no_data_available", "No data available")}</p>}

        {!loading &&
          rows.map(row =>
            row.type === XENTRY_ROW_TYPE.Section ? (
              <div key={row.id} className={`section level-${row.level}`}>
                <span>{row.label}</span>
              </div>
            ) : (
              <div key={row.id} className={`row level-${row.level}`}>
                <span>{row.label}</span>
                <span>{row.value}</span>
              </div>
            )
          )}
      </Modal.Content>
    </Modal>
  );
};
